import { render, staticRenderFns } from "./sortingcenter.vue?vue&type=template&id=0a1765a6"
import script from "./sortingcenter.vue?vue&type=script&lang=js"
export * from "./sortingcenter.vue?vue&type=script&lang=js"
import style0 from "./sortingcenter.vue?vue&type=style&index=0&id=0a1765a6&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports